import { Container } from "../../ui/containers/Container";
import { ButtonComp } from "../../ui/input/Button";
import { Scene, setScene } from "../../ui/scene";
import { createElement } from "../../ui/ui";
import { HomeComponent } from "../ui/home/homeComponent";
import { GameScene } from "./game";
import { MapGenScene } from "./mapgen";

export class Main extends Scene {
  ui = createElement(HomeComponent, { x: 0, y: 0, w: 80, h: 48 });
}
